
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  AreaChart,
  Area,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { useDispatch, useSelector } from 'react-redux';
import { Typography } from "@mui/material";

// Bell curve distribution percentages
const bellCurvePercentages = {
  BE: 0.05,
  MME: 0.60,
  MAE: 0.30,
  O: 0.05,
};

// Category mapping: internal keys → API keys
const categoryMap = {
  BE: "BELOW EXPECTATION",
  MME: "MEETS MOST EXPECTATIONS",
  MAE: "MEETS ALL EXPECTATIONS",
  O: "OUTSTANDING",
};

const BellCurveReport = () => {
  const [data, setData] = useState([]);
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [completedEmployees, setCompletedEmployees] = useState(0);
  const [PendingEmployees, setPendingEmployees] = useState(0);

  const dispatch = useDispatch();

  const { getBellCurveReportByAppraisalYear } = useSelector((state) => state?.getBellCurveReportByAppraisalYear);

  console.log(getBellCurveReportByAppraisalYear?.data, "getBellCurveReportByAppraisalYear");


  useEffect(() => {
    const fetchData = async () => {
      try {
        // const response = await axios.post(
        //   "http://localhost:5000/api/v1/getBellCurveReportByAppraisalYear",
        //   { appraisal_year_id: 1 }
        // );

        const summary = getBellCurveReportByAppraisalYear?.data?.summary;
        const total = summary?.total || 0;
        const completed = summary?.COMPLETED || 0;
        const pending = summary?.NOT_COMPLETED || 0;


        setTotalEmployees(total);
        setCompletedEmployees(completed);
        setPendingEmployees(pending)

        const chartData = Object.entries(categoryMap).map(([key, apiKey]) => {
          const actual = summary?.[apiKey] || 0;
          const norm = Math.round(total * bellCurvePercentages[key]);
          return {
            category: key,
            Actual: actual,
            Norms: norm,
            Deviation: norm - actual,
          };
        });

        setData(chartData);
      } catch (error) {
        console.error("Failed to fetch bell curve data", error);
      }
    };

    fetchData();
  }, [getBellCurveReportByAppraisalYear]);

  return (
    <div style={{ padding: "20px" }}>
      {/* Top Summary */}
      <Typography variant="subtitle2" sx={{ color: "black" ,mt:2}}><strong>Employee HC:</strong> {totalEmployees}</Typography>
      <Typography variant="subtitle2" sx={{ color: "black",mt:2 }}><strong>Completed HC:</strong> {completedEmployees}</Typography>
      <Typography variant="subtitle2" sx={{ color: "black" ,mt:2,mb:2}}><strong>Pending HC:</strong> {PendingEmployees}</Typography>

      {/* Table */}
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginBottom: "40px",
        }}
      >
        <thead style={{ backgroundColor: "#f2f2f2" }}>
          <tr>
            <th style={thStyle}><Typography variant="subtitle2" sx={{ color: "black" }}>Category</Typography></th>
            <th style={thStyle}><Typography variant="subtitle2" sx={{ color: "black" }}>Norms</Typography></th>
            <th style={thStyle}><Typography variant="subtitle2" sx={{ color: "black" }}>Actual</Typography></th>
            <th style={thStyle}><Typography variant="subtitle2" sx={{ color: "black" }}>Deviation</Typography></th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row.category}>
              <td style={tdStyle}><Typography variant="subtitle2" sx={{ color: "black" }}>{row.category}</Typography></td>
              <td style={tdStyle}>{row.Norms}</td>
              <td style={tdStyle}>{row.Actual}</td>
              <td style={tdStyle}>{row.Deviation}</td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Chart */}
      <Typography variant="subtitle2" sx={{ color: "black" }}>Bell Curve</Typography>

      <ResponsiveContainer width="100%" height={470}>
        <AreaChart data={data} margin={{ top: 20, right: 15, left: 20, bottom: 40 }}>
          <defs>
            <linearGradient id="colorActual" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#d3eadb" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#d3eadb" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="category"
            label={{
              value: "Evaluation Rating",
              position: "insideBottom",
              offset: -5,
              style: { fontWeight: "bold" },
            }}
          />
          <YAxis
            label={{
              value: "Employee Count",
              angle: -90,
              position: "insidecenter",
              style: { fontWeight: "bold" },
            }}
          />
          <Tooltip />
          <Legend verticalAlign="top" height={36} />
          <Area
            type="monotone"
            dataKey="Actual"
            stroke="#2ca46d"
            fillOpacity={1}
            fill="url(#colorActual)"
            name="Actual (PMS Score Count)"
          />
          <Line
            type="monotone"
            dataKey="Norms"
            stroke="#f5a623"
            strokeDasharray="5 5"
            dot={{ stroke: "#f5a623", strokeWidth: 2 }}
            name="Norms (Expected Count)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

const thStyle = {
  border: "1px solid #ccc",
  padding: "10px",
  textAlign: "left",
};

const tdStyle = {
  border: "1px solid #ccc",
  padding: "10px",
};

export default BellCurveReport;
